import React, { Component } from "react";
import {
  Grid,
  Icon,
  Button,
  Divider,
  Dropdown,
  Label,
  Form
} from "semantic-ui-react";
import "./custinfo.css";
class Location extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      editing: false,
      editvalue: {},
      deletevalue: [],
      deletelist: [],
      editinfo: {},
      newlocation: false
    };
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.locations !== undefined && this.state.list.length === 0) {
      this.genlocation();
    }
  }
  componentDidMount() {
    if (this.props.locations !== undefined && this.state.list.length === 0) {
      this.genlocation();
    }
  }
  genlocation() {
    var list = this.props.locations.map(item => {
      return {
        key: item.code,
        value: item,
        text: item.code + " - " + item.description
      };
    });
    var locationCodes = this.props.locations.map(item => item.code);
    this.setState({ list, locationCodes });
  }
  handlesave() {
    if (this.state.newlocation) {
      this.props
        .create(this.state.editvalue)
        .then(res => this.setState({ newlocation: false, editvalue: res }));
    } else {
      this.props.handleupdateitems(
        this.state.editvalue,
        this.state.editvalue.custnumber,
        "customers"
      );
    }
  }
  handledelete() {
    let deletepayload = [];
    this.state.deletevalue.map(dl => {
      let newtitle = dl.code + " - " + dl.description;
      let newitem = {
        title: newtitle,
        id: dl.id
      };
      deletepayload.push(newitem);
    });
    this.props.handleDelete(deletepayload, "locations");
  }
  geneditform() {
    let location = Object.assign({}, this.state.editvalue);

    if (this.state.editing !== false) {
      var formtitle;
      if (this.state.newlocation === true) {
        formtitle = "Add Location";
      }
      if (this.state.newlocation === false) {
        formtitle = "Edit:";
      }
      return (
        <div>
          <Grid>
            <Grid.Column width={2}>
              <h3>{formtitle}</h3>
            </Grid.Column>
            <Grid.Column width={4}>
              <h4>{location.description}</h4>
            </Grid.Column>
            <Grid.Column width={4}>
              <h4>{location.code}</h4>
            </Grid.Column>
            <Grid.Column width={3}>
              <Button
                id="billingsavebtn"
                color={this.state.newlocation ? "blue" : "green"}
                onClick={() => this.handlesave()}
              >
                {this.state.newlocation ? "Create Location" : "Save"}
              </Button>
              <Button
                id="billingsavebtn"
                onClick={() => this.setState({ editing: false })}
              >
                Cancel
              </Button>
            </Grid.Column>
          </Grid>
          <Divider />
          <Form>
            <Grid>
              <Grid.Column width={7}>
                <Form.Group>
                  <Form.Input
                    width={8}
                    label="Location Code"
                    error={
                      this.state.newlocation &&
                      this.state.locationCodes.includes(location.code)
                    }
                    value={location.code}
                    onChange={e => {
                      location.code = e.target.value;
                      this.setState({ editvalue: location, newitem: false });
                    }}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Input
                    width={7}
                    label="Location Locale"
                    value={location.description}
                    onChange={e => {
                      location.description = e.target.value;
                      this.setState({ editvalue: location, newitem: false });
                    }}
                  />
                </Form.Group>
              </Grid.Column>
            </Grid>
          </Form>
        </div>
      );
    }
  }

  render() {
    var newlocation = {
      code: "",
      description: ""
    };
    return (
      <div className="Location">
        <Grid>
          <Grid.Column width={5}>
            <Label>Select Locations to Edit</Label>

            <Dropdown
              placeholder="Conact"
              fluid
              search
              selection
              options={this.state.list}
              onChange={(e, { value }) => {
                this.setState({
                  editvalue: value,
                  editing: true,
                  newlocation: false
                });
              }}
            />
          </Grid.Column>
          <Grid.Column width={2}>
            <Button
              color="blue"
              id="deletecontactbutton"
              onClick={() =>
                this.setState({
                  editing: true,
                  newlocation: true,
                  editvalue: newlocation
                })
              }
            >
              <Icon name="plus" /> Location
            </Button>
          </Grid.Column>
          <Grid.Column width={6}>
            <Label>Select Locations to Delete</Label>
            <Dropdown
              placeholder="Select Billing Contact to Delete"
              fluid
              search
              selection
              multiple
              options={this.state.list}
              onChange={(e, { value }) => {
                this.setState({ deletevalue: value });
              }}
            />
          </Grid.Column>
          <Grid.Column width={1}>
            <Button
              negative
              id="deletecontactbutton"
              onClick={() => this.handledelete()}
            >
              Delete
            </Button>
          </Grid.Column>
        </Grid>
        <Divider />

        {this.geneditform()}
      </div>
    );
  }
}
export default Location;



// WEBPACK FOOTER //
// ./src/components/customerinfo/location.js